import React from 'react';
import { Skeleton } from '@components/main-components/skeleton/Skeleton';

export const ReleaseRowSkeleton = () => {
  return (
    <div className="flex h-16 w-full animate-pulse items-center justify-between gap-2 rounded-lg hover:bg-base50">
      <div className="flex items-center gap-3">
        <Skeleton className="h-12 w-12 rounded-lg" />
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-16 rounded-md" />
          <Skeleton className="h-4 w-8 rounded-md" />
        </div>
      </div>
      <Skeleton className="h-6 w-7 rounded-md" />
    </div>
  );
};
